import { Routes } from '@angular/router';
// Guards
import { AuthGuard } from './guards/auth.guard';
import { AuthReverseGuard } from './guards/auth-reverse.guard';
import { ShoppingCartGuard } from './guards/shopping-cart.guard';
import { CatalogueGuard } from './guards/catalogue.guard';
import { ReferralGuard } from './guards/referral.guard';
import { NewsGuard } from './guards/news.guard';
import { FeedGuard } from './guards/feed.guard';
import { VariantSelectorGuard } from './guards/variant-selector.guard';
import { WalletGuard } from './guards/wallet.guard';
const ɵ0 = () => import("./home/home.module.ngfactory").then(m => m.HomePageModuleNgFactory), ɵ1 = () => import("./pages/missions/missions.module.ngfactory").then(m => m.MissionsPageModuleNgFactory), ɵ2 = () => import("./pages/mission-detail/mission-detail.module.ngfactory").then(m => m.MissionDetailPageModuleNgFactory), ɵ3 = () => import("./pages/products/products.module.ngfactory").then(m => m.ProductsPageModuleNgFactory), ɵ4 = () => import("./pages/products/products.module.ngfactory").then(m => m.ProductsPageModuleNgFactory), ɵ5 = () => import("./pages/products/products.module.ngfactory").then(m => m.ProductsPageModuleNgFactory), ɵ6 = () => import("./pages/products/products.module.ngfactory").then(m => m.ProductsPageModuleNgFactory), ɵ7 = () => import("./pages/product-detail/product-detail.module.ngfactory").then(m => m.ProductDetailPageModuleNgFactory), ɵ8 = () => import("./pages/profile/profile.module.ngfactory").then(m => m.ProfilePageModuleNgFactory), ɵ9 = () => import("./pages/shopping-cart/shopping-cart.module.ngfactory").then(m => m.ShoppingCartPageModuleNgFactory), ɵ10 = () => import("./pages/login/login.module.ngfactory").then(m => m.LoginPageModuleNgFactory), ɵ11 = () => import("./pages/delivery-address/delivery-address.module.ngfactory").then(m => m.DeliveryAddressPageModuleNgFactory), ɵ12 = () => import("./pages/complete-order/complete-order.module.ngfactory").then(m => m.CompleteOrderPageModuleNgFactory), ɵ13 = () => import("./modals/product-slides/product-slides.module.ngfactory").then(m => m.ProductSlidesPageModuleNgFactory), ɵ14 = () => import("./modals/modal-add-address/modal-add-address.module.ngfactory").then(m => m.ModalAddAddressPageModuleNgFactory), ɵ15 = () => import("./modals/modal-points-info/modal-points-info.module.ngfactory").then(m => m.ModalPointsInfoPageModuleNgFactory), ɵ16 = () => import("./modals/modal-redeem-coupon/modal-redeem-coupon.module.ngfactory").then(m => m.ModalRedeemCouponPageModuleNgFactory), ɵ17 = () => import("./modals/modal-order-detail/modal-order-detail.module.ngfactory").then(m => m.ModalOrderDetailPageModuleNgFactory), ɵ18 = () => import("./modals/restore-password/restore-password.module.ngfactory").then(m => m.RestorePasswordPageModuleNgFactory), ɵ19 = () => import("./pages/reset-password/reset-password.module.ngfactory").then(m => m.ResetPasswordPageModuleNgFactory), ɵ20 = () => import("./modals/modal-code-question/modal-code-question.module.ngfactory").then(m => m.ModalCodeQuestionPageModuleNgFactory), ɵ21 = () => import("./modals/modal-complete-information/modal-complete-information.module.ngfactory").then(m => m.ModalCompleteInformationPageModuleNgFactory), ɵ22 = () => import("./pages/mission-responses/mission-responses.module.ngfactory").then(m => m.MissionResponsesPageModuleNgFactory), ɵ23 = () => import("./pages/epayco-confirmation/epayco-confirmation.module.ngfactory").then(m => m.EpaycoConfirmationPageModuleNgFactory), ɵ24 = () => import("./pages/epayco-response/epayco-response.module.ngfactory").then(m => m.EpaycoResponsePageModuleNgFactory), ɵ25 = () => import("./pages/tigo/listar-referidos/listar-referidos.module.ngfactory").then(m => m.ListarReferidosPageModuleNgFactory), ɵ26 = () => import("./modals/tigo/modal-request-tigo-sale-order/modal-request-tigo-sale-order.module.ngfactory").then(m => m.ModalRequestTigoSaleOrderPageModuleNgFactory), ɵ27 = () => import("./pages/news/news.module.ngfactory").then(m => m.NewsPageModuleNgFactory), ɵ28 = () => import("./modals/news-detail/news-detail.module.ngfactory").then(m => m.NewsDetailPageModuleNgFactory), ɵ29 = () => import("./pages/feed/feed.module.ngfactory").then(m => m.FeedPageModuleNgFactory), ɵ30 = () => import("./modals/post-comments/post-comments.module.ngfactory").then(m => m.PostCommentsPageModuleNgFactory), ɵ31 = () => import("./modals/modal-user-goal-state/modal-user-goal-state.module.ngfactory").then(m => m.ModalUserGoalStatePageModuleNgFactory), ɵ32 = () => import("./modals/modal-user-answers-questions/modal-user-answers-questions.module.ngfactory").then(m => m.ModalUserAnswersQuestionsPageModuleNgFactory), ɵ33 = () => import("./pages/trade-representative/trade-representative.module.ngfactory").then(m => m.TradeRepresentativeModuleNgFactory), ɵ34 = () => import("./modals/accept-terms-and-conditions/accept-terms-and-conditions.module.ngfactory").then(m => m.AcceptTermsAndConditionsPageModuleNgFactory), ɵ35 = () => import("./pages/dependents/dependents.module.ngfactory").then(m => m.DependentsPageModuleNgFactory), ɵ36 = () => import("./pages/variant-selector/variant-selector.module.ngfactory").then(m => m.VariantSelectorPageModuleNgFactory), ɵ37 = () => import("./pages/kpi/kpi.module.ngfactory").then(m => m.KpiPageModuleNgFactory), ɵ38 = () => import("./pages/wallet/wallet.module.ngfactory").then(m => m.WalletPageModuleNgFactory), ɵ39 = () => import("./pages/oauth/oauth.module.ngfactory").then(m => m.OauthPageModuleNgFactory), ɵ40 = () => import("./modals/automatic-points-settings/automatic-points-settings.module.ngfactory").then(m => m.AutomaticPointsSettingsPageModuleNgFactory), ɵ41 = () => import("./modals/modal-additional-questions/modal-additional-questions.module.ngfactory").then(m => m.ModalAdditionalQuestionsPageModuleNgFactory), ɵ42 = () => import("./modals/modal-ia-results-resume/modal-ia-results-resume.module.ngfactory").then(m => m.ModalIaResultsResumePageModuleNgFactory), ɵ43 = () => import("./modals/filter-resume-results-by-date/filter-resume-results-by-date.module.ngfactory").then(m => m.FilterResumeResultsByDatePageModuleNgFactory), ɵ44 = () => import("./modals/modal-ia-not-approved-rules/modal-ia-not-approved-rules.module.ngfactory").then(m => m.ModalIaNotApprovedRulesPageModuleNgFactory), ɵ45 = () => import("./modals/modal-ia-activity-description/modal-ia-activity-description.module.ngfactory").then(m => m.ModalIaActivityDescriptionPageModuleNgFactory);
const routes = [
    { path: '', redirectTo: 'inicio', pathMatch: 'full' },
    {
        path: 'inicio',
        loadChildren: ɵ0,
        canActivate: [CatalogueGuard]
    },
    {
        path: 'misiones',
        loadChildren: ɵ1,
        canActivate: [AuthGuard]
    },
    {
        path: 'misiones/:id',
        loadChildren: ɵ2,
        canActivate: [AuthGuard]
    },
    {
        path: 'productos',
        loadChildren: ɵ3,
        canActivate: [CatalogueGuard]
    },
    {
        path: 'productos/:category',
        loadChildren: ɵ4,
        canActivate: [CatalogueGuard]
    },
    {
        path: 'productos/:category/:product-tag',
        loadChildren: ɵ5,
        canActivate: [CatalogueGuard]
    },
    {
        path: 'productos-en-promocion/:promotion',
        loadChildren: ɵ6,
        canActivate: [CatalogueGuard]
    },
    {
        path: 'producto/:id',
        loadChildren: ɵ7,
        canActivate: [CatalogueGuard]
    },
    {
        path: 'perfil',
        loadChildren: ɵ8,
        canActivate: [AuthGuard]
    },
    {
        path: 'carrito-de-compras',
        loadChildren: ɵ9,
        canActivate: [AuthGuard]
    },
    {
        path: 'autenticacion',
        loadChildren: ɵ10,
        canActivate: [AuthReverseGuard]
    },
    {
        path: 'detalles-de-entrega',
        loadChildren: ɵ11,
        canActivate: [AuthGuard, ShoppingCartGuard]
    },
    {
        path: 'complete-order',
        loadChildren: ɵ12,
        canActivate: [AuthGuard, ShoppingCartGuard]
    },
    {
        path: 'product-slides',
        loadChildren: ɵ13
    },
    {
        path: 'modal-add-address',
        loadChildren: ɵ14
    },
    {
        path: 'modal-points-info',
        loadChildren: ɵ15
    },
    {
        path: 'modal-redeem-coupon',
        loadChildren: ɵ16
    },
    {
        path: 'modal-order-detail',
        loadChildren: ɵ17
    },
    {
        path: 'restore-password',
        loadChildren: ɵ18
    },
    {
        path: 'recuperar-credenciales/:uid/:token',
        loadChildren: ɵ19
    },
    {
        path: 'modal-code-question',
        loadChildren: ɵ20
    },
    {
        path: 'modal-complete-information',
        loadChildren: ɵ21
    },
    {
        path: 'respuestas/:id',
        loadChildren: ɵ22,
        canActivate: [AuthGuard]
    },
    {
        path: 'epayco-confirmation',
        loadChildren: ɵ23
    },
    {
        path: 'epayco-response',
        loadChildren: ɵ24
    },
    // {
    //   path: 'registro-referidos',
    //   loadChildren: () => import('./pages/tigo/registro-referidos/registro-referidos.module').then(m => m.RegistroReferidosPageModule),
    //   canActivate: [ReferralGuard]
    // },
    {
        path: 'listar-referidos',
        loadChildren: ɵ25,
        canActivate: [ReferralGuard]
    },
    {
        path: 'modal-request-tigo-sale-order',
        loadChildren: ɵ26
    },
    {
        path: 'noticias',
        loadChildren: ɵ27,
        canActivate: [AuthGuard, NewsGuard]
    },
    {
        path: 'news-detail',
        loadChildren: ɵ28
    },
    {
        path: 'muro',
        loadChildren: ɵ29,
        canActivate: [AuthGuard, FeedGuard]
    },
    {
        path: 'post-comments',
        loadChildren: ɵ30
    },
    {
        path: 'modal-user-goal-state',
        loadChildren: ɵ31
    },
    {
        path: 'modal-user-answers-questions',
        loadChildren: ɵ32
    },
    {
        path: 'trade-representative',
        loadChildren: ɵ33,
        canActivate: [AuthGuard]
    },
    {
        path: 'accept-terms-and-conditions',
        loadChildren: ɵ34
    },
    {
        path: 'dependents',
        loadChildren: ɵ35
    },
    {
        path: 'selector-programa',
        loadChildren: ɵ36,
        canActivate: [AuthGuard, VariantSelectorGuard]
    },
    {
        path: 'kpi/:slug',
        loadChildren: ɵ37,
        canActivate: [AuthGuard]
    },
    {
        path: 'billetera',
        loadChildren: ɵ38,
        canActivate: [AuthGuard, WalletGuard]
    },
    {
        path: 'oauth',
        loadChildren: ɵ39
    },
    {
        path: '**',
        redirectTo: 'inicio'
    },
    {
        path: 'automatic-points-settings',
        loadChildren: ɵ40
    },
    {
        path: 'modal-additional-questions',
        loadChildren: ɵ41
    },
    {
        path: 'modal-ia-results-resume',
        loadChildren: ɵ42
    },
    {
        path: 'filter-resume-results-by-date',
        loadChildren: ɵ43
    },
    {
        path: 'modal-ia-not-approved-rules',
        loadChildren: ɵ44
    },
    {
        path: 'modal-ia-activity-description',
        loadChildren: ɵ45
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40, ɵ41, ɵ42, ɵ43, ɵ44, ɵ45 };
